// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","sticky":"CmsVrmLookupTrust_sticky__e_lXa"};